import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { selectData } from 'layouts/onboarding'
import { callZapier } from 'utils/zapier/callZapier'

import { IntakeContext } from 'context/IntakeContext'
import { memo, useState, useContext, useEffect, useCallback } from 'react'
import { Box, Button, Card, IconButton, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
//Accordion
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import { useFegliCalculations } from '../hooks/useFegliCalculations'
import { UpdatedCalcs } from 'admin/UpdatedCalcs'
import { useSearchParams } from 'react-router-dom'
import { CSAssets } from './CSAssets'
import { PropertyAssets } from './PropertyAssets'
import { InvestmentAssets } from './InvestmentAssets'
import { OtherAssets } from './OtherAssets'
import { OtherLiabilities } from './OtherLiabilities'
import { MortgageLiabilities } from './MortgageLiabilities'
import { CreditCardLiabilities } from './CreditCardLiabilities'
import { TspLoans } from './TspLoans'
import { BalanceSheetModalForm } from './BalanceSheetModalForm'
import { UpdateFieldModalForm } from './UpdateFieldModalForm'
import { UpdateRetirementFieldModalForm } from './UpdateRetirementFieldModalForm'
import { ImportFromPlaid } from './ImportFromPlaid'
import { apiClient } from 'utils/api/apiClient'
import { BalanceSheetRow } from './BalanceSheet/BalanceSheetRow'
import Slide from '@mui/material/Slide'

// Dialog
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

function createInitialData(name, amount) {
  return { name, amount }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

// createData('Replace', '$', '$', '$'),

export const LifeInsuranceTable = () => {
  const { intakeState, updateUser, updateIntakeStateAtKey } =
    useContext(IntakeContext)
  const [searchParams, setSearchParams] = useSearchParams()
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [type, setType] = useState()
  const [name, setName] = useState()
  const [plaidName, setPlaidName] = useState()
  const [subType, setSubType] = useState()
  const [sortKey, setSortKey] = useState()
  const [amount, setAmount] = useState()
  const [subTypeClassification, setSubTypeClassification] = useState()
  const [interestRate, setInterestRate] = useState()
  const [monthlyPayment, setMonthlyPayment] = useState()
  const [loanEndDate, setLoanEndDate] = useState()
  const [modalTitle, setModalTitle] = useState()
  const [open, setOpen] = useState(false)
  const [openFieldModal, setOpenFieldModal] = useState(false)
  const [openDialogModal, setOpenDialogModal] = useState(false)
  const [openRetirementFieldModal, setOpenRetirementFieldModal] =
    useState(false)
  const {
    allLifeInsuranceTotal,
    annualLeaveNet,
    survivorBenefitValue,
    totalEstate,
    grossCoverageNeeded,
  } = useFegliCalculations()
  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])
  const [deductions, setDeductions] = useState([])

  const getAccounts = useCallback(async () => {
    const {
      data: { items },
    } = await apiClient.get('api/assets')
    const foundAssets = items?.filter(({ type }) => type === 'asset') || []
    setAssets(foundAssets)
    const foundLiabilities =
      items?.filter(({ type }) => type === 'liability') || []
    setLiabilities(foundLiabilities)
    const foundDeductions =
      items?.filter(({ type }) => type === 'deduction') || []
    setDeductions(foundDeductions)
  }, [])

  useEffect(() => {
    let fetched = false
    if (fetched) return

    getAccounts()
    fetched = true
  }, [getAccounts])

  const { readinessScoreAdjustedMax } = UpdatedCalcs({ assets, liabilities })

  const gaugeSettings = {
    width: 150,
    height: 150,
    value: Math.round(readinessScoreAdjustedMax * 100),
  }

  const improveScoreHelp = () => {
    callZapier({
      user: intakeState,
      hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/3zmzqpy/',
      payload: {
        user: {
          firstName: intakeState.firstName,
          lastName: intakeState.lastName,
          phoneNumber: intakeState.phone,
          email: intakeState.email,
        },
      },
      sendNotification: true,
      notificationMessage:
        'A member of the PARCO team will reach out to you shortly! Expect a call to help improve your retirement readiness.',
    })
  }

  const handleCSClickOpen = () => {
    setOpen(true)
    setSubType('checkingsavings')
    setType('asset')
    setModalTitle('Add a Checking or Savings Account')
  }

  const handleViewAsset = ({
    id,
    typeSubTypeUuid,
    _version,
    name,
    plaidName,
    amount,
    subType,
    subTypeClassification,
  }) => {
    setType('asset')
    setId(id)
    setVersion(_version)
    setSortKey(typeSubTypeUuid)
    setName(name)
    setPlaidName(plaidName)
    setSubType(subType)
    setAmount(amount)
    setOpen(true)
    setModalTitle(`Update ${name}`)
    setSubTypeClassification(subTypeClassification)
  }

  const handleViewLiability = ({
    id,
    typeSubTypeUuid,
    _version,
    name,
    plaidName,
    amount,
    subType,
    subTypeClassification,
    interestRate,
    loanEndDate,
    monthlyPayment,
  }) => {
    setType('liability')
    setId(id)
    setVersion(_version)
    setSortKey(typeSubTypeUuid)
    setName(name)
    setPlaidName(plaidName)
    setSubType(subType)
    setAmount(amount)
    setOpen(true)
    setModalTitle(`Update ${name}`)
    setSubTypeClassification(subTypeClassification)
    setInterestRate(interestRate)
    setLoanEndDate(loanEndDate)
    setMonthlyPayment(monthlyPayment)
  }

  const handlePropertyClickOpen = () => {
    setOpen(true)
    setSubType('property')
    setType('asset')
    setModalTitle('Add a Property')
  }

  const handleInvestmentClickOpen = () => {
    setOpen(true)
    setSubType('investment')
    setType('asset')
    setModalTitle('Add An Investment')
  }

  const handleOtherAssetClickOpen = () => {
    setOpen(true)
    setSubType('otherassets')
    setType('asset')
    setModalTitle('Add An Asset')
  }

  const handleOtherLiabilityClickOpen = () => {
    setOpen(true)
    setSubType('otherliabilities')
    setType('liability')
    setModalTitle('Add a Liability')
  }

  const handleMortgageClickOpen = () => {
    setOpen(true)
    setSubType('mortgage')
    setType('liability')
    setModalTitle('Add a Mortgage')
  }

  const handleTSPLoanClickOpen = () => {
    setOpen(true)
    setSubType('tspLoan')
    setType('liability')
    setModalTitle('Add a TSP Loan')
  }

  const handleCCClickOpen = () => {
    setOpen(true)
    setSubType('creditcard')
    setType('liability')
    setModalTitle('Add a Credit Card')
  }

  const handleSubmit = () => {
    handleClose()
  }

  const handleClose = () => {
    setOpen(false)
    setVersion('')
    setId('')
    setType('')
    setName('')
    setPlaidName('')
    setSubType('')
    setAmount('')
    setSortKey('')
    setModalTitle('')
    setSubTypeClassification('')
    setInterestRate('')
    setLoanEndDate('')
    setMonthlyPayment('')
  }

  const handleAssetClickOpen = () => {
    setOpen(true)
    // setSubType('')
    setType('asset')
    setModalTitle('Add An Asset')
  }

  const handleLiabilityClickOpen = () => {
    setOpen(true)
    setSubType('')
    setType('liability')
    setModalTitle('Add a Liability')
  }
  const handleFieldModalOpen = () => {
    setOpenFieldModal(true)
  }
  const handleFieldModalClose = () => {
    setOpenFieldModal(false)
    updateUser()
  }
  const handleRetirementFieldModalOpen = () => {
    setOpenRetirementFieldModal(true)
  }
  const handleRetirementFieldModalClose = () => {
    setOpenRetirementFieldModal(false)
    updateUser()
  }
  const handleDialogModalOpen = () => {
    setOpenDialogModal(true)
  }
  const handleDialogModalClose = () => {
    setOpenDialogModal(false)
  }
  const handleCallMeClose = () => {
    improveScoreHelp()
    setOpenDialogModal(false)
  }
  const handleScheduleCallClose = () => {
    setOpenDialogModal(false)
  }

  const dollarFormat = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })

  const assetSum =
    (assets || []).map((assets) => assets.amount).reduce((a, b) => a + b, 0) +
    (intakeState.tspBalance ? intakeState.tspBalance : 0)

  const liabilitySum = (liabilities || [])
    .map((liabilities) => liabilities.amount)
    .reduce((a, b) => a + b, 0)

  const netWorth = assetSum - liabilitySum
  const totalEstateWithNetWorth = totalEstate + netWorth

  const legacyGap = totalEstateWithNetWorth - grossCoverageNeeded
  const legacyScore = Math.round(
    (totalEstateWithNetWorth / grossCoverageNeeded) * 100
  )

  const initialSources = [
    createInitialData('Net Worth', dollarFormat.format(netWorth)),
  ]

  const normalizedGross = []
  normalizedGross.push(
    createInitialData(
      'Life Insurance',
      dollarFormat.format(allLifeInsuranceTotal?.coverage || 0)
    )
  )
  normalizedGross.push(
    createInitialData('Annual Leave', dollarFormat.format(annualLeaveNet || 0))
  )
  normalizedGross.push(
    createInitialData(
      'Survivor Benefit Value',
      dollarFormat.format(survivorBenefitValue || 0)
    )
  )
  normalizedGross.push(
    createInitialData(
      'Total Estate',
      dollarFormat.format(totalEstateWithNetWorth)
    )
  )

  const otherDeductions = [
    createInitialData(
      'Gross Coverage Needed',
      dollarFormat.format(grossCoverageNeeded)
    ),
    createInitialData(
      legacyGap > 0 ? 'Estate Surplus' : 'Life Insurance Gap',
      dollarFormat.format(legacyGap)
    ),
  ]
  const tableDivider = [createInitialData('\u00A0', '\u00A0')]
  const tableColors = {
    full:
      legacyScore > 80 ? '#4CAF50' : legacyScore > 60 ? '#FFCA59' : '#FD5C70',
    highlight:
      legacyScore > 80 ? '#c9e7ca' : legacyScore > 60 ? '#fcf0d7' : '#feced4',
  }

  return (
    <>
      <BalanceSheetModalForm
        handleClose={handleClose}
        type={type}
        name={name}
        amount={amount}
        version={version}
        id={id}
        subType={subType}
        setVersion={setVersion}
        setId={setId}
        setType={setType}
        setSubType={setSubType}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        setName={setName}
        plaidName={plaidName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        key={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={getAccounts}
        modalHeader={modalTitle}
      />
      <Card
        sx={{
          textAlign: 'left',
          boxShadow: 0,
          borderRadius: '0px 0px 8px 8px',
        }}
      >
        <Box px={2} mt={2} mb={1} display="flex" justifyContent="space-between">
          <Typography
            variant="h3"
            fontWeight="medium"
            fontSize={{ xs: '20px', md: '24px' }}
            color="#75787B"
          >
            Estate Summary
          </Typography>
          {/* <Button
            variant="gradient"
            color="dark"
            sx={{ height: '100%' }}
            startIcon={<EditIcon fontSize="medium" />}
          >
            Edit
          </Button> */}
        </Box>
        <BalanceSheetRow
          accounts={assets}
          handleAddAccount={handleAssetClickOpen}
          category={'AllAssets'}
          handleViewAccount={handleViewAsset}
          accountType="Assets"
          addAccountButtonText="Add An Asset"
          assetsWithTSP={assetSum}
        />
        <BalanceSheetRow
          accounts={liabilities}
          handleAddAccount={handleLiabilityClickOpen}
          category={'AllLiabilities'}
          handleViewAccount={handleViewLiability}
          accountType="Liabilities"
          addAccountButtonText="Add a Liability"
        />

        <TableContainer
          component={Paper}
          sx={{
            borderRadius: '0px 0px 8px 8px',
          }}
        >
          <Table
            hoverRow
            sx={{}}
            size="small"
            aria-label="income reconciliation table"
          >
            <TableBody>
              {initialSources.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      border: 0,
                    },
                    '&:last-of-type': {
                      borderTop: '2px solid #bbb',
                      borderBottom: '1px solid #ddd',
                    },
                    '&:last-of-type td': {
                      fontWeight: '600',
                    },
                    '&:last-of-type td:last-of-type': {
                      color: '#262627',
                    },
                  }}
                >
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="right">{row.amount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableBody>
              {normalizedGross.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      border: 0,
                    },
                    '&:last-of-type': {
                      borderTop: '2px solid #bbb',
                      borderBottom: '1px solid #ddd',
                    },
                    '&:last-of-type td, &:last-of-type th': {
                      fontWeight: '600',
                    },
                  }}
                >
                  <TableCell component="th">{row.name}</TableCell>
                  <TableCell align="right">{row.amount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableBody>
              {tableDivider.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      border: 0,
                    },
                    '&:last-of-type': {
                      borderBottom: '1px solid #ddd',
                    },
                    '&:last-of-type td, &:last-of-type th': {
                      fontWeight: '600',
                    },
                  }}
                >
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="right">{row.amount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableBody>
              {otherDeductions.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      border: 0,
                    },
                    '&:last-of-type': {
                      borderTop: '2px solid #bbb',
                    },
                    td: {
                      fontWeight: '600',
                    },
                    '&:last-of-type td:last-of-type': {
                      border: `4px solid ${tableColors.full}`,
                      backgroundColor: tableColors.highlight,
                    },
                  }}
                >
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="right">{row.amount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  )
}
